import * as React from "react";
import { auth } from "../../../firebase";
import { Button } from "@rmwc/button";

export const SignOutButton = ({ history }) => (
  <Button type="button" onClick={() => auth.doSignOut(history)}>
    Sign Out
  </Button>
);
